import { render, staticRenderFns } from "./DeviceBrand.vue?vue&type=template&id=5b00b1c4&scoped=true&"
import script from "./DeviceBrand.vue?vue&type=script&lang=js&"
export * from "./DeviceBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b00b1c4",
  null
  
)

export default component.exports